import React from "react";
import { RouteProps } from "react-router-dom";
import { routeConstants } from "@/shared/constants";
import loadable from "@/shared/utils/loadable";

const OptimiseRoutes = loadable(import("./index"));

const OptimiseRoutesRoute: RouteProps = {
  path: routeConstants["optimise-routes"].route,
  element: React.createElement(OptimiseRoutes),
};

export default OptimiseRoutesRoute;
